import { AppText, kindredFontFamilies } from "../../ui-foundation";
import { DocumentPageScaffold, DocumentSection } from "@/components/DocumentScaffold";
import { STEADY_HOUSE_LEGAL_NAME } from "../../shared/support";

const sections = [
  {
    emoji: "🎯",
    title: "What Kindred is for",
    body: `Kindred is a safe, active, family-focused community for single parent families. Every moderation decision should serve this purpose. ${STEADY_HOUSE_LEGAL_NAME} is responsible for the moderation and safeguarding outcomes delivered through this guidance. When in doubt, ask: does this make Kindred safer and more useful for single parent families?`,
  },
  {
    emoji: "📋",
    title: "Community guidelines summary",
    body: "Be kind. Be honest about being a single parent. No advertising or self-promotion. No hate, discrimination, or targeted abuse. No unsolicited advice to newly separated members. No politics or news. Children's safety is paramount — any content that could put a child at risk must be escalated immediately.",
  },
  {
    emoji: "⚠️",
    title: "Act immediately on",
    body: "Anything that could be a safeguarding risk. Any post targeting a specific member with personal abuse. Anything that appears to be grooming or exploitation. Any content that would make a vulnerable new member feel unsafe. Don't wait for the full queue process — hide the content first, then escalate.",
  },
  {
    emoji: "🤔",
    title: "Grey areas",
    body: "Heated disagreements that aren't abusive. Posts that might be venting vs. genuinely harmful. Parenting debates that get pointed. The guidance: give the benefit of the doubt once, act if it continues, and escalate to admin if you're genuinely unsure. It's better to escalate than to make a call you're not confident about.",
  },
  {
    emoji: "🔄",
    title: "The escalation path",
    body: "Handle it yourself: clear-cut cases, minor warnings, obvious spam. Escalate to admin: anything involving account suspension or banning, anything with potential legal implications, anything where you're genuinely unsure. Write a clear escalation note — say what you saw, what you did, and why you're escalating.",
  },
  {
    emoji: "🫡",
    title: "Looking after yourself",
    body: "Moderating content in a community dealing with difficult life circumstances can be heavy. If you see something distressing, step back. Escalate the item first, then take a break. Your wellbeing matters. This is a volunteer role, not a job. If you need to step back from moderating, tell Hannah.",
  },
];

const ModerationGuidance = () => {
  return (
    <DocumentPageScaffold
      title="Moderation Guidance"
      updatedLabel="Internal use only"
      fallbackPath="/my-kindred"
      footerLinks={[{ href: "mailto:hello@kindredcommunity.app", label: "Contact" }]}
      footerNote="Internal Kindred guidance for moderators."
    >
      {sections.map((section) => (
        <DocumentSection key={section.title} title={section.title}>
          <AppText fontFamily={kindredFontFamilies.display} fontSize="$xxl" lineHeight="$xxl">
            {section.emoji}
          </AppText>
          <AppText color="$colorMuted" fontSize="$sm" lineHeight="$md">
            {section.body}
          </AppText>
        </DocumentSection>
      ))}
    </DocumentPageScaffold>
  );
};

export default ModerationGuidance;
